import { render, staticRenderFns } from "./headSetting.vue?vue&type=template&id=30d7ba38&scoped=true&"
import script from "./headSetting.vue?vue&type=script&lang=js&"
export * from "./headSetting.vue?vue&type=script&lang=js&"
import style0 from "./headSetting.vue?vue&type=style&index=0&id=30d7ba38&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d7ba38",
  null
  
)

export default component.exports